export const StringUtils = {
  sanitizeVehicleNumber (vehicleNo) {
    return vehicleNo.toUpperCase().trim().replace(/[^0-9A-Z-_ ]/ig, '').replace(/\s+/g, '')
  }
}



// WEBPACK FOOTER //
// ./src/utils/util.js